const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-7 py-3.5 text-base font-medium hover:bg-[#e8463c] transition-colors";

export function SparkSessionsCTA() {
  return (
    <section
      data-testid="spark-cta-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #FAFAF8 0%, #FFF1EE 100%)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[35px] md:pt-[57px] pb-[55px] md:pb-[77px]">
        <div className="max-w-2xl mx-auto text-center reveal">
          <h2 className="font-display text-[34px] sm:text-[44px] lg:text-[60px] leading-[1.1] tracking-tight text-[#1C1917] mb-[26px]">
            One task. Ninety minutes. A little more momentum than you had before.
          </h2>
          <p className="text-lg md:text-xl text-[#57534E] leading-relaxed mb-2">
            You don&rsquo;t have to finish everything.
          </p>
          <p className="font-display text-2xl md:text-3xl text-[#159E9A] leading-snug mb-8">
            You just have to begin.
          </p>
          <a
            href="mailto:lara@blueprint4joy.com?subject=Spark%20Sessions"
            data-testid="spark-cta-button"
            className={btnPrimary}
          >
            Join the Next Spark Session
          </a>
        </div>
      </div>
    </section>
  );
}
